import React from 'react';
import Header from 'components/Header';
import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';
import getStaticPathsSite from 'utils/getStaticPathsSite';

import { Box, Typography } from '@lyearn/ui';

function Terms() {
  return (
    <>
      <h1 className="hidden">Terms</h1>
      <Header
        LeftNodeRef="@lyearn/components/Header/BrandInfo"
        RightNodeRef="@lyearn/components/Header/UserAuth"
        centered={true}
        headerStyles={{
          solidBackgroundColor: 'rgba(255, 255, 255, 0.96)',
        }}
        headerType="sticky"
        height="8rem"
        leftNodeProps={{
          isHomepage: true,
        }}
        middleNodeAlign="center"
        rightNodeProps={{
          authType: 'LOGIN_SIGNUP',
          primaryBtn: {
            text: 'Login',
          },
          secondaryBtn: {
            text: 'Create Account',
            variant: 'filled',
          },
        }}
      />
      <Box className="prose prose-2xl mx-auto py-40 px-20">
        <Typography as="h2" variant="heading-xl">
          1. What information does Lyearn Store collect and what do they do with it?
        </Typography>
        <Typography variant="body-long-01">
          Lyearn Store helps organisations and individual entrepreneurs host learning content and
          provide an online store (platform) for continuous engagement. When a learner (user)
          purchases an e-learning product on Lyearn hosted store, we collect personal information as
          provided by the learner such as name and email address. Each company can request us to
          track different fields that will be clearly mentioned. Force Management intends to track
          in addition to name and email address, Company & Role.
        </Typography>
        <Typography variant="body-long-01">
          All user activity such as product purchase, learnings accessed and time spent is captured
          and sent to the backend server and then to the database (both hosted in AWS data centre)
          over a secured “https” connection. The entire connection is end-to-end encrypted so as to
          ensure data integrity throughout the system flow. Further, each user’s data is stored in a
          multi-tenant database so that each tenant’s data is isolated and remains invisible to
          others.
        </Typography>
        <Typography variant="body-long-01">
          Emails: Lyearn Store may send learners emails about their purchase - learning content,
          learning progress, validity expiration. Lyearn Store does not send out any promotional,
          advertising or marketing emails to their email address.
        </Typography>
        <Typography as="h2" variant="heading-xl">
          2. How does Lyearn Store take learner's consent?
        </Typography>
        <Typography variant="body-long-01">
          As a part of signing up on the platform, a user (learner) has to explicity agree to Lyearn
          Store's T&C. By agreeing to it, learner provides Lyearn Store the consent to use their
          personal information to provide them a platform to learn the content hosted, complete a
          purchase, and access additional services provided. Lyearn Store does not collect any
          information when they (learner) interacts with content on third-party sites or platforms,
          such as social networking sites. Lyearn Store doesn't intentionally, share, sell or rent
          individual personal information associated with the user (learner). This data is also
          visible to the Lyearn's client hosting the store. Lyearn Store does not take any
          responsibility for how they choose to interact with the data.
        </Typography>
        <Typography as="h2" variant="heading-xl">
          3. How does Lyearn Store handle Payment:
        </Typography>
        <Typography variant="body-long-01">
          All payments for purchases on Lyearn hosted store are processed through a third party
          service, Stripe. Payments are encrypted through the Payment Card Industry Data Security
          Standard (PCI-DSS). Learner's purchase transaction data is stored only as long as is
          necessary to complete your purchase transaction.
        </Typography>
        <Typography variant="body-long-01">
          All direct payment gateways adhere to the standards set by PCI-DSS as managed by the PCI
          Security Standards Council, which is a joint effort of brands like Visa, MasterCard,
          American Express and Discover.
        </Typography>
        <Typography variant="body-long-01">
          PCI-DSS requirements help ensure the secure handling of credit card information by our
          online store.
        </Typography>
        <Typography variant="body-long-01">
          <a href="https://www.google.com/url?q=https://stripe.com/en-in/privacy&sa=D&ust=1599033195288000&usg=AOvVaw3KWeJfIzw_qhP61JTcYTad">
            Stripe's Privacy Policy
          </a>
        </Typography>
        <Typography as="h2" variant="heading-xl">
          4. Third Party Services used by Lyearn Store
        </Typography>
        <Typography variant="body-long-01">
          In general, the third-party providers used by Lyearn Store will only collect, use and
          disclose learner information to the extent necessary to allow them to perform the services
          they provide to us.
        </Typography>
        <Typography variant="body-long-01">
          However, certain third-party service providers, such as payment gateways and other payment
          transaction processors, have their own privacy policies in respect to the information we
          are required to provide to them for your purchase-related transactions.
        </Typography>
        <Typography variant="body-long-01">
          List of third party services being used on Store
        </Typography>
        <ul>
          <li>Stripe</li>
          <li>Intercom</li>
          <li>Wistia</li>
          <li>Filestack</li>
          <li>SendGrid</li>
        </ul>
        <Typography as="h2" variant="heading-xl">
          5. Cookies on Lyearn Store
        </Typography>
        <Typography variant="body-long-01">
          Lyearn Store collects cookies or similar tracking technologies. This means information
          that our website’s server transfers to the learner's (users) computer. This information
          can be used to track learner sessions on our website. Cookies may also be used to
          customize our website content for learner as an individual. If a learner (user) is using
          one of the common Internet web browsers, they can set up their browser to either let them
          know when they receive a cookie or to deny cookie access to their computer.
        </Typography>
        <Typography variant="body-long-01">
          Lyearn uses cookies to provide the learner (user) with an enhanced personalized
          experience.
        </Typography>
        <Typography as="h2" variant="heading-xl">
          6. Links on Lyearn Store
        </Typography>
        <Typography variant="body-long-01">
          When a learner (user) clicks on links on a Lyearn hosted store, they may direct them away
          from our site. Lyearn Store is not responsible for the privacy practices of other sites
          and encourages learners (users) to read their privacy statements.
        </Typography>
      </Box>
      <NextSeo title="Lyearn Terms" />
    </>
  );
}

export default Terms;

export { getStaticPathsSite as getStaticPaths };

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {},
    revalidate: 180,
  };
};
